import { openPopup, closePopup } from './popups';

const validate = (field, type) => {
  let pp = '';

  if (type === 'email') {
    pp = /^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  }

  if (type === 'onlyNumber') {
    pp = /^([0-9()\\/+ -]+)$/;
  }

  if (type === 'phone') {
    pp = /^\+?[\d()\-\s]*\d+\s*$/;
  }

  if (type === 'date') {
    pp = /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/;
  }

  if (type === 'time') {
    pp = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
  }

  if (type === 'notEmpty') {
    pp = /^[A-Za-zА-Яа-я0-9 _+]*[A-Za-zА-Яа-я0-9][A-Za-zА-Яа-я0-9 _#()$@8%№'":,.+?!#*-/\n]*$/;
  }

  if (type === 'select') {
    pp = /^[A-Za-zА-Яа-я0-9 _+]*[A-Za-zА-Яа-я0-9][A-Za-zА-Яа-я0-9 _#()$@8%№'":,.+?!#*-/\n]*$/;
  }

  if (type === 'checkbox') {
    if (!field) {
      return false;
    }
  } else {
    if (!field.match(pp)) {
      return false;
    }
  }

  return true;
};

let required = 0;
let validated = 0;

function validateInput (input) {
  const fieldType = input.dataset['validate'];
  let value = input.value;
  if (input.getAttribute('type') === 'checkbox') {
    value = input.checked;
  }
  if (!validate(value, fieldType)) {
    if (input.parentNode.classList.contains('has-success')) {
      input.parentNode.classList.remove('has-success');
    }
    input.parentNode.classList.add('has-error');
  } else {
    if (input.parentNode.classList.contains('has-error')) {
      input.parentNode.classList.remove('has-error');
    }
    input.parentNode.classList.add('has-success');
  }
}

function validateInputBool (input) {
  const fieldType = input.dataset['validate'];
  let value = input.value;
  if (input.getAttribute('type') === 'checkbox') {
    value = input.checked;
  }
  if (!validate(value, fieldType)) {
    if (input.parentNode.classList.contains('has-success')) {
      input.parentNode.classList.remove('has-success');
    }
    input.parentNode.classList.add('has-error');
    return false;
  } else {
    if (input.parentNode.classList.contains('has-error')) {
      input.parentNode.classList.remove('has-error');
    }
    input.parentNode.classList.add('has-success');
    return true;
  }
}

function postData (url = '', data = {}) {
  return fetch(url, {
    method: 'post',
    body: data
  })
    .then(response => response);
}

function initForms (parent) {
  const forms = parent.querySelectorAll('form');

  if (forms.length) {
    [...forms].forEach(form => {
      const validateInputsEls = form.querySelectorAll('[data-validate]');

      if (validateInputsEls.length) {
        [...validateInputsEls].forEach(input => {
          input.addEventListener('input', () => {
            validateInput(input);
          });
        });
      }

      form.addEventListener('submit', (e) => {
        const $form = e.target;
        const $submitButton = $form.querySelector('button[type=submit]');
        const formInputsValidate = $form.querySelectorAll('[data-validate]');
        const formInputs = $form.querySelectorAll('.form-field');

        if (formInputsValidate.length) {
          [...formInputsValidate].forEach(input => {
            validateInput(input);
          });
        }

        required = $form.querySelectorAll('[data-validate].required').length;
        validated = $form.querySelectorAll('.has-success').length;

        if (required === validated) {
          return true;
        } else {
          e.preventDefault();
          return false;
        }
      });

      const formClose = form.querySelector('[data-form-close]');

      if (formClose) {
        formClose.addEventListener('click', () => {
          form.classList.remove('is-success');
        });
      }
    });
  }
}

initForms(document);

export { initForms, validate, validateInput, validateInputBool };
